module.exports = __webpack_public_path__ + "img/lookingweb.b082136b.webp";